import React, { useMemo } from "react";

const STATUS_COLORS = {
  compliant: "#047857",
  notDue: "#10B981",
  due: "#F59E0B",
  notCompliant: "#DC2626",
};

const STATUS_LABELS = {
  compliant: "Compliant",
  notDue: "Not Due",
  due: "Due",
  notCompliant: "Not Compliant",
};

const statusOrder = ["compliant", "notDue", "due", "notCompliant"];

const CompliancePieChart = ({ summary = {} }) => {
  const { gradient, total } = useMemo(() => {
    let cumulative = 0;
    const segments = statusOrder.reduce((acc, key) => {
      const value = Math.max(0, Number(summary[key] || 0));
      if (value <= 0) {
        return acc;
      }
      const start = cumulative;
      cumulative += value;
      const end = Math.min(100, cumulative);
      acc.push(`${STATUS_COLORS[key]} ${start}% ${end}%`);
      return acc;
    }, []);

    const gradientValue = segments.length
      ? `conic-gradient(${segments.join(", ")})`
      : "none";

    return {
      gradient: gradientValue,
      total: Math.round(cumulative),
    };
  }, [summary]);

  return (
    <div className="flex flex-col gap-6 md:flex-row md:items-center">
      <div className="flex items-center justify-center">
        <div
          className="relative flex h-40 w-40 items-center justify-center rounded-full bg-gray-100 shadow-inner"
          style={{ backgroundImage: gradient }}
          role="img"
          aria-label={`Compliance distribution: ${statusOrder
            .map(
              (key) =>
                `${STATUS_LABELS[key]} ${Number(summary[key] || 0).toFixed(
                  1
                )} percent`
            )
            .join(", ")}`}
        >
          <div className="flex h-24 w-24 items-center justify-center rounded-full bg-white text-center">
            <span className="text-sm font-semibold text-gray-700">
              {total > 0 ? `${total.toFixed(0)}%` : "No data"}
            </span>
          </div>
        </div>
      </div>
      <ul className="grid flex-1 gap-3 text-sm text-gray-600 md:grid-cols-2">
        {statusOrder.map((key) => (
          <li key={key} className="flex items-center gap-3">
            <span
              className="h-3 w-3 rounded-full"
              style={{ backgroundColor: STATUS_COLORS[key] }}
              aria-hidden="true"
            />
            <div>
              <p className="font-semibold text-gray-700">
                {STATUS_LABELS[key]}
              </p>
              <p className="text-xs text-gray-500">
                {Number(summary[key] || 0).toFixed(2)}%
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CompliancePieChart;
